import { isConsumer } from 'owa-session-store';
import { isFeatureEnabled } from 'owa-feature-flags';
import type { MailboxInfo } from 'owa-client-types';

export default function isSenderScreeningFeatureEnabled(mailboxInfo: MailboxInfo): boolean {
    return (
        isConsumer(undefined, mailboxInfo) && isFeatureEnabled('tri-sender-screening', mailboxInfo)
    );
}
